/**
 * Normalize API error payload from 4xx/5xx responses.
 *
 * Expected response body shape:
 * { status: false, message: string, code: string, data: T | null }
 *
 * @param {unknown} error - Axios error (error.response.data) or object with response.data / data
 * @returns {{ code?: string, message?: string, data?: unknown }}
 */
export function getApiErrorPayload(error) {
  const body = error?.response?.data ?? error?.data ?? error ?? {};
  return {
    code: body?.code ?? body?.error_code,
    message: body?.message,
    data: body?.data ?? undefined,
  };
}
